/**
 * Dieses Modul stellt globale Variablen bereit, die von anderen Modulen benötigt werden.
 * In Modulen darf der Zugriff auf globale Variablen NUR über dieses Modul erfolgen!
 */

export const onlineAvailableUrlKey = window.fxxlOnlineAvailableUrlKey;
export const onlineAvailableUrlValue = window.fxxlOnlineAvailableUrlValue;

export const isLargeViewport = window.isLargeViewport;
export const largViewportSize = window.largViewportSize;

export const changeBranchSwitchState = window.changeBranchSwitchState;

export const fxxl_config_from_php = window.fxxl_config_from_php;

export const FxxlSetupSlider2 = window.FxxlSetupSlider2;

export const fxxlCheckoutExtraAmounts = window.fxxlCheckoutExtraAmounts;

export const addABTastyToHeader = window.addABTastyToHeader;

export const fxxl_CMT_allowed_list = window.fxxl_CMT_allowed_list;

export const addCriteoToHeader = window.addCriteoToHeader;